import { $,Foundation } from '../../../vendor'
import InboomaBaseView from '../InboomaBaseView'

import VoucherTypesSortTabsTpl from '../../templates/vouchers/VoucherTypesSortTabsTpl.html'

export default InboomaBaseView.extend({

    template : VoucherTypesSortTabsTpl,
    el : '#inb-c-main-sort-nav',

    ui : {
        button : 'li.tabs-title'
    },

    events : {
        'click @ui.button' : '_changeCollectionSort',
    },

    initialize () {
        this.render()
    },

    onRender () {
        // https://foundation.zurb.com/sites/docs/sticky.html
        Foundation.Sticky.defaults.marginTop = 0;
        const sticky = new Foundation.Sticky(this.$el);
    },

    _changeCollectionSort (el) {

        el = $(el.currentTarget);

        const val = el.attr('data-inb-val'),
            direction = el.attr('data-inb-direction')

        if (typeof val === 'undefined' || direction === 'undefined') {
            return;
        }

        el.parent()
            .find('.is-active')
            .removeClass('is-active');

        el.addClass('is-active');

        el.attr('data-inb-direction', (direction === 'desc' ? 'asc' : 'desc'));

        this.collection.setSort(val, direction);

        return false;

    }
});